<template>
  <v-container>
    <v-card
      class="mx-auto rounded-lg mt-5"
      elevation="0"
      outlined
      v-if="pageContent"
    >
      <v-card-text class="secondary-font pa-3">
        <v-container class="mt-3 home-page-content" v-html="pageContent">
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "HomeView",
  computed: {
    pageContent() {
      return this.$store.state.common.configurations.campus_home_page_content;
    },
  },
};
</script>
